<script setup>
import { Icon } from '@components'
import { ref, computed } from 'vue'

const showColorBox = ref(false)

const emit = defineEmits(['update:modelValue'])

const props = defineProps({
    modelValue: {
        type: String,
        default: '#2E90FA'
    },
    inputClass: {
        type: String,
    },
    colorBoxClass: {
        type: String,
    },
    borderless: {
        type: Boolean,
        default: false
    },
})

const colors = computed(() => {
    return prebook_admin.options.color_sets
})

/**
 * Gets the value of the color from props.modelValue and sets it to the value of the color and emits an event.
 */
const colorValue = computed({
    get: () => props.modelValue,
    set: (newValue) => {
        return emit('update:modelValue', newValue)
    }
})
</script>

<style>

</style>
<template>
    <div class="relative">
        <div :class="`flex items-center gap-2 px-3.5 py-2.5 cursor-pointer ${inputClass} ${!borderless ? 'border border-[#D0D5DD]' : ''}`" @click="showColorBox = !showColorBox" style="border-radius: 8px">
            <div class="w-6 h-6 rounded-full" :style="{ 'background-color': colorValue }"></div>
            <Icon size="20px" name="chevronDown" class="text-[#667085]"></Icon>
        </div>
        <transition name="slide-fade">
            <div v-if="showColorBox" class="absolute z-[100] -right-full w-[296px] top-[calc(100%_+_12px)] grid grid-cols-7 items-center gap-4 p-4 border bg-white shadow-[0px_4px_6px_-2px_rgba(16,24,40,0.03),0px_12px_16px_-4px_rgba(16,24,40,0.08)] rounded-lg border-[#EAECF0]" :class="colorBoxClass">
                <div v-for="(textColor, bgColor) in colors" :key="index" class="flex items-center justify-center w-6 h-6 rounded-full cursor-pointer" :style="{ 'background-color': bgColor, color: textColor }" @click="colorValue = bgColor, showColorBox = false">

                    <Icon size="16px" name="check" class="text-[#FFFFFF]" v-if="colorValue === bgColor"></Icon>
                </div>
            </div>
        </transition>
    </div>
</template>
